/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmergencySelfSetChatOpened
 */
export interface EmergencySelfSetChatOpened {
    /**
     * 
     * @type {string}
     * @memberof EmergencySelfSetChatOpened
     */
    emergency_id: string;
    /**
     * 
     * @type {string}
     * @memberof EmergencySelfSetChatOpened
     */
    user_history_azure_id: string;
}

/**
 * Check if a given object implements the EmergencySelfSetChatOpened interface.
 */
export function instanceOfEmergencySelfSetChatOpened(value: object): value is EmergencySelfSetChatOpened {
    if (!('emergency_id' in value) || value['emergency_id'] === undefined) return false;
    if (!('user_history_azure_id' in value) || value['user_history_azure_id'] === undefined) return false;
    return true;
}

export function EmergencySelfSetChatOpenedFromJSON(json: any): EmergencySelfSetChatOpened {
    return EmergencySelfSetChatOpenedFromJSONTyped(json, false);
}

export function EmergencySelfSetChatOpenedFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmergencySelfSetChatOpened {
    if (json == null) {
        return json;
    }
    return {
        
        'emergency_id': json['emergency_id'],
        'user_history_azure_id': json['user_history_azure_id'],
    };
}

export function EmergencySelfSetChatOpenedToJSON(json: any): EmergencySelfSetChatOpened {
    return EmergencySelfSetChatOpenedToJSONTyped(json, false);
}

export function EmergencySelfSetChatOpenedToJSONTyped(value?: EmergencySelfSetChatOpened | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'emergency_id': value['emergency_id'],
        'user_history_azure_id': value['user_history_azure_id'],
    };
}

